














































































































































import moment from "moment";
import { Component, Vue } from 'vue-property-decorator';

import Common from '../../common/Common';
import DownloadCsv from '../../common/DownloadCsv';

import { DbUtile } from '../../database/DbUtile';
import { DbHistoryManagement, DbHistoryManagementDetail } from '../../database/DbHistoryManagement'
import { DbCourseManagement } from "../../database/DbCourseManagement";

import BackButton from '@/components/BackButton.vue';
import SectionCourseManagement from '@/components/SectionCourseManagement.vue';
import { AuthUtile } from "../../auth/AuthUtile";

class CheckboxRow {
    cancel = false;
    done = false;
}

@Component({
  components: {
    BackButton,
    SectionCourseManagement
  },
  filters: {
    moment(value: any, format: string) {
      if (value == null) {
        return "---";
      }
      if (typeof value != "string"){
        if ("toDate" in value){
          return moment(value.toDate()).format(format);
        }
      }
      return moment(value).format(format);
    }
  }
})
export default class HistoryManagement extends Vue {
  private authUtile = new AuthUtile();
  private dbUtile = new DbUtile();

  courseManagementId: string | null = null;
  courseManagement: DbCourseManagement | null = null;

  rows: DbHistoryManagement[] = [];

  detailRows: DbHistoryManagementDetail[] = [];
  detailCheckboxRows: CheckboxRow[] = [];

  searchName = "";
  searchStatus = "";

  // 詳細表示 true
  isDetail = false;

  created() {
    console.log('created');
    this.authUtile.checkAuthorizedAdmin()
      .then(() => {
        // 講習
        this.courseManagementId = this.$route.params['id'];
        this.getCourseManagement(this.courseManagementId);

        // 履歴を取得
        this.changeHistoryManagement();
      })
      .catch((e) => {
        console.error('checkAuthorizedAdmin:', e);
        alert(e);
        this.$router.push('/admin/login/');
      });
  }

  status(s: string) {
    console.log('status', s);
    if (s == DbHistoryManagement.STATUS.NotAttended) {
      return "未受講";
    }
    else if (s == DbHistoryManagement.STATUS.During) {
      return "受講中";
    }
    else if (s == DbHistoryManagement.STATUS.Done) {
      return "完了";
    }
  }

  // 履歴を取得
  changeHistoryManagement(): Promise<void> {
    return new Promise((resolve, reject) => {
      const promises: Promise<void>[] = [];
      promises.push( this.getHistoryManagement() );
      promises.push( this.getHistoryManagementDetails() );

      Promise.all(promises)
        .then(() => {
          console.log('changeHistoryManagement success');
          resolve();
        });
    });
  }

  // 概要一覧
  showOverview() {
    // 講習 データを取得
    this.getHistoryManagement();
    this.isDetail = false;
  }

  // 詳細表示
  showDetail() {
    this.getHistoryManagementDetails();
    this.isDetail = true;
  }

  // 講習 データを取得
  getCourseManagement(id: string) {
    this.dbUtile.getCourseManagement(id)
      .then((doc) => {
        console.log(doc)
        this.courseManagement = doc;
      })
  }

  // 履歴を検索して取得
  getHistoryManagement(): Promise<void> {
    return new Promise((resolve, reject) => {
      this.rows = [];
      this.dbUtile.getHistoryManagement(this.courseManagementId!, this.searchName, this.searchStatus)
        .then((rows) => {
          this.$set(this, "rows", this.sortRows( rows ));
          resolve();
        })
        .catch((e) => {
          console.error(e);
          reject();
        });
    });
  }

  // 履歴詳細を取得
  getHistoryManagementDetails(): Promise<void> {
    return new Promise((resolve, reject) => {
      this.detailRows = [];
      this.detailCheckboxRows = [];
      this.dbUtile.getHistoryManagementDetails(this.courseManagementId!, this.searchName, this.searchStatus)
        .then((rows) => {
          // ソートする
          const detailRows = this.sortDetailRows(rows);
          this.$set(this, "detailRows", detailRows);
          // チェックボックス用 データを生成する
          rows.forEach((r) => {
            this.detailCheckboxRows.push(new CheckboxRow());
          });
          resolve();
        })
        .catch((e) => {
          console.error(e);
          reject();
        });
    });
  }

  changeCancelAll(event: any) {
    console.log('changeCancelAll', event.target.checked);
    // 一覧の 取り消しチェックボックスを event.target.checked
    this.detailCheckboxRows.forEach((r) => {
      r.cancel = event.target.checked;
    });
  }

  changeDoneAll(event: any) {
    console.log('changeDoneAll', event.target.checked);
    // 一覧の 完了 チェックボックスを event.target.checked に変更
    this.detailCheckboxRows.forEach((r) => {
      r.done = event.target.checked;
    });
  }

  // 変更
  change() {
    // 取消：完了 → 未受講、完了：未受講 → 完了、受講開始日時=未入力、受講完了日時=未入力に更新
    // 取消チェックボックスは、分類=「ライブ配信」かつ状態=「完了」のときのみ活性
    // 完了チェックボックスは、分類=「ライブ配信」かつ状態=「未受講」のときのみ活性

    if ( window.confirm("受講状態を変更しますが、よろしいですか？") == false) return;
    // 完了にチェックが入力されている 履歴詳細 を元に ユーザー講習詳細 を完了にする
    const checkboxCancelAll: any = this.$refs.checkboxCancelAll;
    if (checkboxCancelAll) {
      checkboxCancelAll.checked = false;
    }
    const checkboxDoneAll: any = this.$refs.checkboxDoneAll;
    if (checkboxDoneAll) {
      checkboxDoneAll.checked = false;
    }

    let i = 0;
    this.detailRows.forEach((r) => {
      console.log('r', r);
      if ( this.detailCheckboxRows[i].cancel == true){
        // キャンセル処理
        if (r.status == DbHistoryManagementDetail.STATUS.Done){
          // 取消：完了 → 未受講
          r.status = DbHistoryManagementDetail.STATUS.NotAttended;
        }
      }
      else if ( this.detailCheckboxRows[i].done == true){
        // 完了処理
        if (r.status == DbHistoryManagementDetail.STATUS.NotAttended){
          // 完了：未受講 → 完了
          r.status = DbHistoryManagementDetail.STATUS.Done;
        }
      }
      i++;
    });

    // チェックボックス内容でDBを更新する
    this.dbUtile.courseManagementStatusUpdate(this.courseManagementId!, this.detailRows, this.detailCheckboxRows)
      .then(() => {
        // 一覧の更新
        this.getHistoryManagementDetails();
      });
  }

  // CSV出力
  downloadCsv() {
    console.log('downloadCsv', this.$refs.csvLink);
    this.changeHistoryManagement()
      .then(() => {
        DownloadCsv.downloadCsv(this.$refs.csvLink, this.courseManagement!, this.rows, this.detailRows);
      });
  }

  // 履歴概要 ソート
  sortRows(rows: DbHistoryManagement[]){
    return rows.sort((a,b) => {
      // 申込番号
      if(a.applicationNumber > b.applicationNumber){
        return 1;
      }
      else if(a.applicationNumber < b.applicationNumber){
        return -1;
      }
      return 0;
    });
  }

  // 履歴詳細 ソート
  sortDetailRows(detailRows: DbHistoryManagementDetail[]){
    return detailRows.sort((a,b) => {
      // 分科会番号、章ID、申込番号
      if((a == null) || (b == null)){
        return 0;
      }
      // 分科会番号
      if(a.subcommitteeNumber > b.subcommitteeNumber){
        return 1;
      }
      else if(a.subcommitteeNumber < b.subcommitteeNumber){
        return -1;
      }

      // 章ID
      if(a.chapterID > b.chapterID){
        return 1;
      }
      else if(a.chapterID < b.chapterID){
        return -1;
      }

      // 申込番号
      if(a.applicationNumber > b.applicationNumber){
        return 1;
      }
      else if(a.applicationNumber < b.applicationNumber){
        return -1;
      }

      return 0;
    });
  }

  //「取消」：分類=「ライブ配信」かつ状態=「完了」のときのみ活性
  isCheckboxCancel(row: DbHistoryManagementDetail): boolean {
    if ((row.classification == "ライブ配信")
        && (row.status == DbHistoryManagementDetail.STATUS.Done)) {
      return true;
    }
    return false;
  }
  //「完了」：分類=「ライブ配信」かつ状態=「未受講」のときのみ活性
  isDoneboxCancel(row: DbHistoryManagementDetail): boolean {
    if ((row.classification == "ライブ配信")
        && (row.status == DbHistoryManagementDetail.STATUS.NotAttended)) {
      return true;
    }
    return false;
  }
}
